class CategoryMegaMenu extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.tabs = [...this.querySelectorAll('[data-category-tab]')];
    this.panels = [...this.querySelectorAll('[data-category-panel]')];
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
    const tablist = this.querySelector('.category-mega__tabs');
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-orientation', 'vertical');
    this.tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', this.panels[index].id);
      this.panels[index].setAttribute('role', 'tabpanel');
      this.panels[index].tabIndex = 0;
      tab.addEventListener('click', event => {
        event.preventDefault();
        clearTimeout(this.hoverTimer);
        this.select(index);
      }, { signal });
      tab.addEventListener('pointerenter', event => {
        if (this.dataset.hover !== 'true' || event.pointerType !== 'mouse') return;
        // Do not hide a panel while a keyboard user is interacting with it.
        if (this.panels.some(panel => panel.contains(document.activeElement))) return;
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(() => this.select(index), 120);
      }, { signal });
      tab.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer), { signal });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (event.key === ' ') next = index;
        if (next === undefined) return;
        event.preventDefault();
        clearTimeout(this.hoverTimer);
        this.select(next);
        this.tabs[next].focus();
      }, { signal });
    });
    this.select(0);
    this.observer?.disconnect();
    this.observer = new ResizeObserver(() => this.updateHeight());
    this.observer.observe(this);
  }
  select(index) {
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      this.panels[i].hidden = i !== index;
    });
    this.querySelector('.category-mega__scroll').scrollTop = 0;
  }
  updateHeight() {
    const submenu = this.closest('.menu-list__submenu');
    const header = this.closest('header-component');
    if (!submenu || submenu.inert || !header) return;
    // More/overflow uses its own height calculation in the original header-menu.js.
    if (this.closest('[slot="overflow"]')) return;
    const height = submenu.offsetHeight;
    const row = header.hasAttribute('data-submenu-overlap-bottom-row') ? header.querySelector('.header__row--top') : header;
    header.style.setProperty('--submenu-height', `${height}px`);
    header.style.setProperty('--full-open-header-height', `${height + (row?.offsetHeight || 0)}px`);
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    clearTimeout(this.hoverTimer);
  }
}
if (!customElements.get('category-mega-menu')) customElements.define('category-mega-menu', CategoryMegaMenu);
